<button class="btn send-to-fda" (click)="showEsignatureModal()"
        tabindex="0" role="button" aria-label="Ok" (keydown.enter)="showEsignatureModal()">
  <i class="fas fa-paper-plane"></i>&nbsp;
  Send to FDA
</button>

<ejs-dialog #esigModal [isModal]='isModal' [animationSettings]='animationSettings' [closeOnEscape]='false'
            [width]='modalWidth' [position]='position' [visible]='sendModalVisible' [showCloseIcon]='false' (open)='showEsignatureModal()'
            [height]='modalHeight' [hidden]='!sendModalVisible' oncontextmenu="return false;"
            aria-hidden="true"
            role="alertdialog"
            aria-modal="true">
  <ng-template #content>
    <form #form="ngForm">
      <div class="card">
        <div class="card-header bg-primary">
          <h3 class="card-title text-white" tabindex="0" aria-label="E-signature Required" role="heading" aria-level="3">E-signature Required</h3>
        </div>
        <div class="card-body">
          <div class="whitespace-padding px-3">
            <h4 class="my-3" tabindex="0" aria-label="Submission Summary" role="heading" aria-level="4">
              Submission Summary
            </h4>
            <div class="submissionSummary">
              <div class="row py-1">
                <div class="col-4 fw-bold" tabindex="0">Client Name: </div>
                <div class="col-8" tabindex="0">{{clientName}}</div>
              </div>
              <div class="row py-1">
                <div class="col-4 fw-bold" tabindex="0">File Name: </div>
                <div class="col-8" tabindex="0">{{localFileName}}</div>
              </div>
              <div class="row py-1">
                <div class="col-4 fw-bold" tabindex="0">Document Type:</div>
                <div class="col-8" tabindex="0">{{localDocumentType}}</div>
              </div>
              <div class="row py-1">
                <div class="col-4 fw-bold" tabindex="0">SPL Version Number: </div>
                <div class="col-8" tabindex="0">{{localSplVersionNumber | number:'1.0-0' }}</div>
              </div>
              <div class="row py-1">
                <div class="col-4 fw-bold" tabindex="0">FDA Center: </div>
                <!--This one is actually hardcoded for now-->
                <div class="col-8" tabindex="0">OC</div>
              </div>
              <div class="row py-1">
                <div class="col-4 fw-bold" tabindex="0">Submission Type: </div>
                <!--This one is actually hardcoded for now-->
                <div class="col-8" tabindex="0">SPL</div>
              </div>
              <div class="row py-1">
                <div class="col-4 fw-bold" tabindex="0">Submitter: </div>
                <div class="col-8" tabindex="0">{{submitterName}}</div>
              </div>
              <div class="row py-1">
                <div class="col-4 fw-bold" tabindex="0">Submission Date: </div>
                <div class="col-8" tabindex="0">{{submissionDate}}</div>
              </div>
            </div>
            <h4 class="my-3" tabindex="0" aria-label="Submission Confirmation" role="heading" aria-level="4">
              Confirm the submission of this SPL file
            </h4>
            <div aria-label="Esignature confirmation acknowledging">
              <p tabindex="0">
                By providing your username and password, you are acknowledging that all information is in accordance
                with the recipient health authority guidelines and approving the submission to the health authority.
              </p>
              <div class="text-danger extra-bottom-margin" [hidden]='eSignatureConfirmed' tabindex="0">
                {{eSignatureErrorMessage}}
              </div>
            </div>

            <div class="d-flex flex-column">
              <div class="my-2">
                <div class="class='form-group">
                  <label id="email-label" for="txtConfirm" tabindex="0">Email</label>
                  <input id='txtUserName' type='email' class="form-control" aria-required="true"
                         aria-label="Enter user name (email)" aria-labelledby="email-label" tabindex="0"
                         (blur)="onEmailBlur($event)">
                </div>
              </div>
              <div class="my-2">
                <div class="class='form-group">
                  <label id="password-input" for="txtPassword" tabindex="0">Password</label>
                  <input id='txtPassword' type='password' class="form-control" aria-required="true"
                         aria-label="Enter password" aria-labelledby="password-input" tabindex="0">
                </div>
              </div>
              <!--------------------------------
                     PROGRESS SPINNER
              ---------------------------------->
              <div *ngIf="showloading">
                <div id="loading"></div>
              </div>
              <div class="text-center py-2">
                <button id="btnCancel" type="button" class="btn btn-default dialogButton mx-3" aria-label="Cancel" tabindex="0"
                        (click)="eSigCancel($event)"
                        (keydown.enter)="eSigCancel()">
                  Cancel
                </button>

                <button id="btnConfirm" type="button" class="btn btn-primary dialogButton mx-3"
                        aria-label="Confirm" tabindex="0"
                        (click)="confirmClicked()"
                        (keydown.enter)="confirmClicked()">
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </form>
  </ng-template>
</ejs-dialog>

<ejs-dialog #postAuthMessageModal [isModal]='isModal'
            [button]
            [visible]='false' [position]='position'
            [animationSettings]='animationSettings'
            [width]='modalWidth'
            role="alertdialog"
            aria-modal="true">
  <ng-template #content>
    <div class="card">
      <div class="card-header bg-primary">
        <h3 class="card-title text-white" tabindex="0" aria-label="FDA Submission Status" role="heading" aria-level="3">FDA Submission Status</h3>
      </div>
      <div class="card-body">
        <div>
          <div tabindex="0">
            Your SPL submission is being packaged and will be submitted to the FDA.
            You may track the submission process from the <a href="/submission-dashboard" tabindex="0" aria-label="ESG Dashboard Link" role="link">ESG dashboard.</a>
          </div>
        </div>
        <div class="text-end">
          <button id="postAuthCloseButton" class="btn btn-primary" (click)="postAuthClose($event)" data-ripple="true"
                  tabindex="0" role="button" aria-label="Ok" (keydown.enter)="postAuthClose($event)">
            OK
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</ejs-dialog>

<ejs-dialog #noEsgAccessModal [isModal]='isModal'
            [button]
            [visible]='false' [position]='position'
            [animationSettings]='animationSettings'
            [width]='modalWidth'
            role="alertdialog"
            aria-modal="true">
  <ng-template #content>
    <div class="card">
      <div class="card-header bg-primary">
        <h3 class="card-title text-white" tabindex="0" aria-label="FDA Submission Status" role="heading" aria-level="3">FDA Submission Status</h3>
      </div>
      <div class="card-body">
        <div>
          <div tabindex="0">
            Your Site is not enabled for ESG submissions to the FDA. Contact pharma@reedtech.com to add this ability.
          </div>
        </div>
        <div class="text-end">
          <button id="noAccessModalClose" class="btn btn-primary" (click)="noAccessModalClose($event)" data-ripple="true"
                  tabindex="0" role="button" aria-label="Ok" (keydown.enter)="noAccessModalClose($event)">
            OK
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</ejs-dialog>
